// File: src/components/teams/hooks/useMemberProfileFields.js
import { useEffect, useState } from 'react';
import { doc } from 'firebase/firestore';
import { safeOnSnapshot } from '../../../utils/firestoreSubscriptions';
import { db } from '../../../firebase-client';
export function useMemberProfileFields(teamId, uid) {
  const [memberProfile, setMemberProfile] = useState({
    profileFields: {},
    profileUpdateRequestOpen: false,
    profileUpdateRequestedAt: null
  });
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    if (!teamId || !uid) {
      setMemberProfile({
        profileFields: {},
        profileUpdateRequestOpen: false,
        profileUpdateRequestedAt: null
      });
      setLoading(false);
      return undefined;
    }
    setLoading(true);
    const ref = doc(db, 'teams', teamId, 'members', uid);
    const unsub = safeOnSnapshot(ref, snap => {
      const data = snap.exists() ? snap.data() : {};
      setMemberProfile({
        profileFields: data?.profileFields || {},
        profileUpdateRequestOpen: Boolean(data?.profileUpdateRequestOpen),
        profileUpdateRequestedAt: data?.profileUpdateRequestedAt || null
      });
      setLoading(false);
    }, () => {
      setMemberProfile({
        profileFields: {},
        profileUpdateRequestOpen: false,
        profileUpdateRequestedAt: null
      });
      setLoading(false);
    });
    return () => unsub();
  }, [teamId, uid]);
  return {
    profileFields: memberProfile.profileFields,
    profileUpdateRequestOpen: memberProfile.profileUpdateRequestOpen,
    profileUpdateRequestedAt: memberProfile.profileUpdateRequestedAt,
    loading
  };
}
